var render = function render(){var _vm=this,_c=_vm._self._c;return _c('App',[_c('AppBar',{staticStyle:{"width":"100%"}},[_c('AppTitle',{attrs:{"icon":"logo-angular","name":"AI 实验室"}}),_c('AppTabs',{attrs:{"items":_vm.items,"actived":_vm.actived},on:{"on-click":_vm.handleClick}}),_c('div')],1),_c('AppClient',{staticStyle:{"overflow":"hidden"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }